
      import Print from './print.vue'
      import type { App, Plugin } from 'vue'

      export const PrintPlugin: Plugin = {
        install(app: App) {
          app.component('Print', Print)
        },
      }
      export { Print }
      